/**
 * The service for web sockets.
 * Contains the logic for initializing, connecting and disconnecting web sockets using stomp over sock.
 */
var WebSocketsService = /** @class */ (function () {
    /*@ngInject*/
    function WebSocketsService($q, $rootScope, $timeout, StorageService) {
        var _this = this;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.StorageService = StorageService;
        this.urlConstants = {
            WEB_SOCKET_CONNECTION_URL: 'register',
            ECHO_URL: '/topic/echo',
            USER_NOTIFICATIONS: '/queue/{userId}/notifications',
            MESSAGE_NOTIFICATIONS: '/queue/{userId}/chatMessage',
            WORKFLOW_UPDATE: '/queue/{userId}/workflowUpdate',
            SEND_URL: '/send/url',
            WEB_SOCKET_CONNECTION_URL_FOR_CHIME: 'register/chime',
            CHIME_NOTIFICATIONS: '/chime/{participantId}/notifications'
        };
        this.chimeParticipantId = null;
        this.isChimeListenerListening = false;
        this.listener = this.$q.defer();
        this.listenerForChime = this.$q.defer();
        this.messageListener = this.$q.defer();
        this.workflowUpdateListener = this.$q.defer();
        this.socket = {
            client: null,
            stomp: null
        };
        this.socketForChime = {
            client: null,
            stomp: null
        };
        this.messageIds = [];
        this.reconnect = function () {
            _this.$timeout(function () {
                _this.initialize();
            }, 6000);
        };
        this.reconnectForChime = function () {
            _this.$timeout(function () {
                _this.initializeForChime();
            }, 6000);
        };
        this.initialize = function () {
            if ((_.isNull(_this.socket.stomp) || !_this.socket.stomp.connected) && _this.StorageService.get('userDetails')) {
                _this.socket.client = new SockJS(_this.StorageService.get('baseurl') + _this.urlConstants.WEB_SOCKET_CONNECTION_URL);
                _this.socket.stomp = Stomp.over(_this.socket.client);
                _this.socket.stomp.connect({}, _this.startListener, _this.reconnect);
            }
        };
        this.initializeForChime = function () {
            if ((_.isNull(_this.socketForChime.stomp) || !_this.socketForChime.stomp.connected)) {
                _this.socketForChime.client = new SockJS(_this.StorageService.get('baseurl') + _this.urlConstants.WEB_SOCKET_CONNECTION_URL_FOR_CHIME);
                _this.socketForChime.stomp = Stomp.over(_this.socketForChime.client);
                _this.socketForChime.stomp.connect({}, _this.startListenerForChime, _this.reconnectForChime);
            }
        };
        this.getMessage = function (data) {
            var message = JSON.parse(data.body);
            return message;
        };
        this.disconnect = function () {
            if (!_.isNull(_this.socket.stomp) && _this.socket.stomp.connected) {
                _this.socket.stomp.disconnect(function () {
                    console.log("Web socket disconnected.");
                });
            }
        };
        this.disconnectForChime = function () {
            if (!_.isNull(_this.socketForChime.stomp) && _this.socketForChime.stomp.connected) {
                _this.socketForChime.stomp.disconnect(function () {
                    console.log("Web socket for chime disconnected.");
                });
            }
        };
        this.startListener = function () {
            _this.socket.stomp.subscribe(_this.urlConstants.USER_NOTIFICATIONS.replace('{userId}', _this.$rootScope.userDetails.id), function (data) {
                _this.listener.notify(_this.getMessage(data));
            });
            _this.socket.stomp.subscribe(_this.urlConstants.MESSAGE_NOTIFICATIONS.replace('{userId}', _this.$rootScope.userDetails.id), function (data) {
                _this.messageListener.notify(_this.getMessage(data));
            });
            _this.socket.stomp.subscribe(_this.urlConstants.WORKFLOW_UPDATE.replace('{userId}', _this.$rootScope.userDetails.id), function (data) {
                console.log('Workflow Update alert:');
                console.log(_this.getMessage(data));
                _this.workflowUpdateListener.notify(_this.getMessage(data));
            });
        };
        this.startListenerForChime = function () {
            _this.$rootScope.$emit("CHIME_WEBSOCKET_CONNECTED", null);
            _this.socketForChime.stomp.subscribe(_this.urlConstants.CHIME_NOTIFICATIONS.replace('{participantId}', _this.chimeParticipantId), function (data) {
                _this.listenerForChime.notify(_this.getMessage(data));
            });
        };
    }
    WebSocketsService.prototype.connect = function () {
        this.initialize();
    };
    WebSocketsService.prototype.connectForChime = function (chimeParticipantId) {
        this.chimeParticipantId = chimeParticipantId;
        this.initializeForChime();
    };
    WebSocketsService.prototype.receive = function () {
        return this.listener.promise;
    };
    WebSocketsService.prototype.receiveMessage = function () {
        return this.messageListener.promise;
    };
    WebSocketsService.prototype.receiveWorkflowUpdate = function () {
        return this.workflowUpdateListener.promise;
    };
    WebSocketsService.prototype.receiveChimeNotification = function () {
        this.isChimeListenerListening = true;
        return this.listenerForChime.promise;
    };
    WebSocketsService.prototype.send = function (message) {
        var id = Math.floor(Math.random() * 1000000);
        this.socket.stomp.send(this.urlConstants.SEND_URL, {
            priority: 9
        }, JSON.stringify({
            message: message,
            id: id
        }));
        this.messageIds.push(id);
    };
    WebSocketsService.prototype.setWorkflowUpdateListener = function () {
        this.workflowUpdateListener = this.$q.defer();
    };
    WebSocketsService.prototype.resetWorkflowUpdateListener = function () {
        this.workflowUpdateListener.resolve();
        this.setWorkflowUpdateListener();
    };
    return WebSocketsService;
}());
export { WebSocketsService };
//# sourceMappingURL=webSocketsService.js.map